import workletURL from '~/assets/paint-worklets/squircle.js?url';

export default function registerSquircleWorklet() {
  if (import.meta.client && CSS && 'paintWorklet' in CSS) {
    (CSS as unknown as CSSWithPaintWorklet).paintWorklet.addModule(workletURL);
  }

  interface CSSWithPaintWorklet {
    paintWorklet: { addModule: (url: string) => void };
  }
}
